import { Controller } from "@hotwired/stimulus";
import { todoResolved } from "../back_office/utils/todos";

export default class extends Controller {
  resolved() {
    todoResolved();
  }
}
